import { Option } from 'space-lift';
import { RootState } from '..';

export const getRouterState = (state: RootState) =>
  Option(state.router.location!.state).getOrElse({}) as { useCustomBack?: boolean };
